module.exports = __webpack_public_path__ + "static/wanderson-0841ce37236ac5d313034b7444f5cc19.jpg";